<template>
  <page style="position: relative">
    <metabase-application :project-id="projectId" />
  </page>
</template>

<script>
import MetabaseApplication from './MetabaseApplication'
import Page from '../../../common/components/page/Page'
export default {
  name: 'MetabaseProjectPage',

  components: { Page, MetabaseApplication },

  computed: {
    projectId() {
      return this.$route.query.project_id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseProjectPage.vue